import { Component } from '../helpers/helper';
import { router } from '../router';
import { store_url } from '../state';
import { base_api, store_api } from '../storeAPI';

class AdminState {
	error_log_url = `${base_api}/log.txt`;
	coreApps = [];
	stats: IServerStats = null;
	suggestions: ISuggestion[] = [];
	bans: any[] = [];

	async init() {
		store_api.getCoreApps().then(r => (this.coreApps = r || []));
		store_api.getSuggestions().then(r => (this.suggestions = r));
		this.refreshStats();
		this.refreshBans();
	}

	clearErrorLog() {
		fetch(`${base_api}/nuke_log`);
	}

	deploy(name: string) {
		store_api.deployCoreApp(name);
	}

	refreshStats() {
		store_api.getServerStats().then(stats => {
			this.stats = stats;
		});
	}

	refreshBans() {
		store_api.getBans().then(bans => {
			this.bans = bans || [];
		});
	}

	async deleteBan(id: string) {
		if (confirm('Are you sure you want to unban this user?')) {
			await store_api.deleteBan(id);
			this.refreshBans();
		}
	}

	async cleanOldChannels() {
		await fetch(`${base_api}/clean-old-channels`);
		this.refreshStats();
	}
}

export const AdminPage = Component(() => {
	const l = Vue.reactive(new AdminState());
	l.init();

	return () => (
		<div class="store-page page-light admin">
			<h1>Admin Functions</h1>
			<div id="buttons">
				<a class="button" onClick={e => l.cleanOldChannels()}>
					Clean Old Channels
				</a>
				<a class="button" href={base_api + '/deploy'} target="_blank">
					Deploy
				</a>
			</div>
			<div id="buttons">
				<a
					class="button"
					onClick={e => {
						router.push('/metrics');
					}}
				>
					Metrics
				</a>
				<a class="button" href={store_url + '/logs/error.txt'} target="_blank">
					Error Log
				</a>
				<a class="button" onClick={e => l.clearErrorLog()}>
					Clear Error Log
				</a>
				<a class="button" href={store_url + '/logs/deploy.log'} target="_blank">
					Deploy Log
				</a>
			</div>
			<h3 style="margin-top: 1em">Stats:</h3>
			<a onClick={e => l.refreshStats()}>[Refresh]</a>
			{l.stats && (
				<div>
					<table>
						<tr>
							<td>user sockets:</td>
							<td>{l.stats.user_sockets}</td>
						</tr>
						<tr>
							<td>app sockets:</td>
							<td>
								{Object.keys(l.stats.app_sockets).map(key => (
									<div key="key">
										{key}:&nbsp;{l.stats.app_sockets[key]}
									</div>
								))}
							</td>
						</tr>
						<tr>
							<td>channels:</td>
							<td>
								{l.stats.channels.map(c => (
									<div key="c.name" style="display: flex; margin-bottom: 0.25em">
										<span class="channel">
											name: {c.name}&nbsp;|&nbsp;vclient: {c.vclient}&nbsp;|&nbsp;users: {c.users}&nbsp;|&nbsp;apps:
											{c.apps.map(app => (
												<span>{app}</span>
											))}
										</span>
									</div>
								))}
							</td>
						</tr>
					</table>
				</div>
			)}
			<h3 style="margin-top: 1em">Suggestions:</h3>
			{l.suggestions.map(s => (
				<div key="s.id">
					<span>
						{s.name} [{s.email}] - {s.date}
					</span>
					<code>{s.message}</code>
				</div>
			))}
			<h3 style="margin-top: 1em">Channel Bans:</h3>
			<a onClick={e => l.refreshBans()}>[Refresh]</a>
			{l.bans.length === 0 && <p>No bans found</p>}
			{l.bans.length > 0 && (
				<table style="width: 100%; margin-top: 1em; border-collapse: collapse;">
					{console.log(l.bans)}
					<thead>
						<tr style="background-color: #f0f0f0; text-align: left;">
							<th style="padding: 8px; border: 1px solid #ddd;">Channel ID</th>
							<th style="padding: 8px; border: 1px solid #ddd;">User ID</th>
							<th style="padding: 8px; border: 1px solid #ddd;">IP Address</th>
							<th style="padding: 8px; border: 1px solid #ddd;">Banned By</th>
							<th style="padding: 8px; border: 1px solid #ddd;">Banned At</th>
							<th style="padding: 8px; border: 1px solid #ddd;">Actions</th>
						</tr>
					</thead>
					<tbody>
						{l.bans.map(ban => (
							<tr key={ban.id}>
								<td style="padding: 8px; border: 1px solid #ddd;">{ban.channel_id}</td>
								<td style="padding: 8px; border: 1px solid #ddd;">{ban.user_id || 'N/A'}</td>
								<td style="padding: 8px; border: 1px solid #ddd;">{ban.ip_address}</td>
								<td style="padding: 8px; border: 1px solid #ddd;">{ban.banned_by || 'N/A'}</td>
								<td style="padding: 8px; border: 1px solid #ddd;">
									{new Date(ban.banned_at).toLocaleString()}
								</td>
								<td style="padding: 8px; border: 1px solid #ddd;">
									<button class="button" onClick={() => l.deleteBan(ban.id)} style="background-color: #dc4a4a; color: white;">
										Unban
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			)}
			<h3 style="margin-top: 1em">Core Apps</h3>
			<div id="core-apps">
				{l.coreApps.map(app => (
					<div>
						<button onClick={e => l.deploy(app)}>deploy</button>
						{app}
					</div>
				))}
			</div>
		</div>
	);
});
